import { useParams } from 'react-router-dom'
import { useClient } from '@/modules/clients/hooks/useClient'
import { useClientMutation } from '@/modules/clients/hooks/useClientMutation'
import { useClientPoints } from '@/modules/points/hooks/useClientPoints'
import { usePointMutation } from '@/modules/points/hooks/usePointMutation'
import { useBranchOffices } from '@/modules/clients/hooks/useBranchOffices'
import { useClientBenefits } from '@/modules/benefits/hooks/useClientBenefits'
import { useAvailableBenefits } from '@/modules/benefits/hooks/useAvailableBenefits'
import { ClientDetail } from '@/modules/clients/components/ClientDetail'
import { ErrorState } from '@/shared/components/ui/atoms/ErrorState'

export function ClientDetailPage() {
  const { id } = useParams<{ id: string }>()
  const clientId = Number(id)

  const { data: client, status, isLoading, error } = useClient(clientId)
  const { data: points, isLoading: pointsLoading } = useClientPoints(clientId)
  const { remove, isSubmitting: isDeleting } = useClientMutation()
  const { invalidatePoint } = usePointMutation()
  const { branches } = useBranchOffices()

  const {
    allBenefits,
    vouchers,
    category: benefitCategory,
    usedCount,
    expiredCount,
    activeBenefits,
    isLoading: benefitsLoading,
  } = useClientBenefits(clientId)

  const { tiers, isLoading: availableLoading } = useAvailableBenefits(
    benefitCategory || undefined,
  )

  const branchName = branches.find((b) => b.id === client?.id_branch_office)
  const branchLabel = branchName ? `${branchName.commune} - ${branchName.address}` : null

  if (isLoading) {
    return <div className="animate-pulse h-96 bg-gray-100 rounded-lg" />
  }

  if (error) {
    return <ErrorState message={error} />
  }

  if (!client) return null

  return (
    <ClientDetail
      client={client}
      status={status}
      points={points}
      pointsLoading={pointsLoading}
      onDeleteClient={() => remove(clientId)}
      onInvalidatePoint={(pointId) => invalidatePoint(pointId, clientId)}
      isDeleting={isDeleting}
      branchLabel={branchLabel}
      allBenefits={allBenefits}
      vouchers={vouchers}
      activeBenefitsCount={activeBenefits.length}
      usedBenefitsCount={usedCount}
      expiredBenefitsCount={expiredCount}
      clientCategory={benefitCategory}
      availableTiers={tiers}
      benefitsLoading={benefitsLoading}
      availableLoading={availableLoading}
    />
  )
}
